"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatusData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// The data payload attached to an order status update push notification.
exports.OrderStatusData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("orderStatus"),
    // The uuid of the order which has changed status.
    order: UUID_1.UUID,
    // The uuid of the customer who placed the order.
    customer: UUID_1.UUID,
    // The new status of the order.
    status: (0, runtypes_1.Union)((0, runtypes_1.Literal)("PAYMENT_PENDING"), (0, runtypes_1.Literal)("PAYMENT_FAILED"), (0, runtypes_1.Literal)("NEW"), (0, runtypes_1.Literal)("REJECTED"), (0, runtypes_1.Literal)("IN_PROGRESS"), (0, runtypes_1.Literal)("COMPLETED"), (0, runtypes_1.Literal)("CANCELLED")),
    // The site on which the order was placed.
    site: UUID_1.UUID,
    // @deprecated but retained for backwards compatibility.
    portal: UUID_1.UUID,
}));
//# sourceMappingURL=OrderStatusData.js.map